module.exports = __webpack_public_path__ + "img/newsImg12-15.9fa351de.png";